import ApiService from "../ApiService";

const LoginService = {
	login: (loginData) => {
		return ApiService.post('/auth/login', loginData).catch(error => {console.log(error); throw error;});
	}
}

export default LoginService;